module.exports = __webpack_public_path__ + "img/prize3.c26fc5ce.png";